import { ListDto } from "types/dto";
import * as verificationCodesService from 'services/verificationCodesService';
import { useMutation, useQuery } from "react-query";

const getVerificationCodes = async (dto: ListDto) => {
  return await verificationCodesService.getVerificationCodes(dto);
}

const deleteVerificationCode = async (verificationCodeId: string) => {
  return await verificationCodesService.deleteVerificationCode(verificationCodeId);
}

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

export const useGetVerificationCodes = (
  dto: ListDto,
  options = {}
) => {
  return useQuery({
    queryKey: ['verificationCodes', dto],
    queryFn: () => getVerificationCodes(dto),
    ...options
  });
}

export const useDeleteVerificationCode = (onSuccess: any, onError: any) => {
    return useMutation(deleteVerificationCode, {
        onSuccess,
        onError
    });
}

